<div class="modal-content">
  <div class="header">
    <p class="titleModal">{{ tarea.titulo }}</p>
    <mat-icon class="closeModal" [mat-dialog-close]>cancel</mat-icon>
  </div>
  <input
    class="form-control"
    type="file"
    hidden
    #fileInput
    (change)="onFile($event)"
    multiple
  />
  <div class="container" style="padding: 0 2rem">
    <div class="information row">
      <div class="col-6">
        <p><b>Fecha de Creación:</b> {{ tarea.createdAt | date: "d/M/yy" }}</p>
        <p><b>Modificado por:</b> {{ tarea.lastUser || "Sin modificar" }}</p>
      </div>
      <div class="col-6">
        <p>
          <b>Última Modificación:</b> {{ tarea.updatedAt | date: "d/M/yy" }}
        </p>
        <p><b>Descripción: </b> {{ tarea.descripcion }}</p>
      </div>
    </div>

    <div class="content-component" *ngIf="ComponentValue">
      <ng-template appComponentValue></ng-template>
    </div>

    <!-- <div *ngIf="caso">
  <div
    [ngClass]="editar?'editTrue':'editFalse'" style="width: 37px;text-align: center;"
    (click)="editarToggle()"
    *ngIf="
      includeAnalistaCasos
      && asignadoAlCaso
      && (tarea.observaciones || tarea.archivos_adjuntos)
      || tarea.titulo === 'Aprobar Evaluación del Especialista'
    "
  >
    <mat-icon style="color: #00abff;cursor: pointer;">edit</mat-icon>
  </div>
</div> -->

    <form
      [formGroup]="form"
      class="style-form-default"
      style="padding: 0"
      *ngIf="tarea.observaciones || tarea.archivos_adjuntos"
    >
      <div
        class="style-input-default column-complete"
        *ngIf="
          (includeAnalistaCasos && asignadoAlCaso && tarea.observaciones) ||
            tarea.titulo === 'Aprobar Evaluación del Especialista';
          else elseObservaciones
        "
      >
        <textarea
          rows="6"
          placeholder="Observaciones..."
          formControlName="observaciones_text"
        ></textarea>
      </div>
      <ng-template #elseObservaciones>
        <div *ngIf="tarea.observaciones" class="column-complete">
          <h4 style="border-bottom: 1px solid #ccc; margin: 0">
            Observaciones
          </h4>
          <p class="observaciones_value" style="white-space: break-spaces">
            {{
              tarea.observaciones_text
                ? tarea.observaciones_text
                : "Sin Observaciones..."
            }}
          </p>
        </div>
      </ng-template>
      <div *ngIf="showAdjuntos" class="column-complete">
        <button
          class="btn-file"
          (click)="archivos_adjuntos()"
          *ngIf="
            (includeAnalistaCasos &&
              asignadoAlCaso &&
              tarea.archivos_adjuntos) ||
            tarea.titulo === 'Aprobar Evaluación del Especialista'
          "
        >
          Subir archivo adjunto
        </button>
        <table class="table mt-2 mb-2" *ngIf="tarea.archivos_adjuntos">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of files">
              <td style="text-align: left">{{ file.filename }}</td>
              <td style="text-align: right">
                <button class="btn-save" (click)="view(file)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button class="btn-save ml-2" (click)="goTo(file.file_path)">
                  <mat-icon>save</mat-icon>
                </button>
                <button
                  class="btn-delete ml-2"
                  (click)="deleteFile(file.filename)"
                  *ngIf="
                    (includeAnalistaCasos &&
                      asignadoAlCaso &&
                      (tarea.observaciones || tarea.archivos_adjuntos)) ||
                    tarea.titulo === 'Aprobar Evaluación del Especialista'
                  "
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>

    <div
      class="checkboxs"
      *ngIf="
        tarea.titulo === 'Aprobar Evaluación del Especialista' &&
        caso.tipo_caso === 'Retención de fondos'
      "
    >
      <label class="checkbox" (click)="estafaC()">
        <span>Estafa SIN personal interno involucrado</span>
        <i
          class="fas fa-{{ form.value.estafa ? 'check-circle' : 'circle' }}"
        ></i>
      </label>
      <label class="checkbox" (click)="personalInterC()">
        <span>Estafa CON personal interno involucrado</span>
        <i
          class="fas fa-{{
            form.value.personalInternoInvolucrado ? 'check-circle' : 'circle'
          }}"
        ></i>
      </label>
      <!-- <label class="checkbox" (click)="ingresosDesconoC()">
        <span>Estafa SIN personal interno involucrado y la cuenta tiene “ingresos no reconocidos”</span>
        <i class="fas fa-{{ form.value.ingresosDescono ? 'check-circle' : 'circle' }}"></i>
      </label> -->
      <div *ngIf="form.value.personalInternoInvolucrado == 'true'">
        <mat-form-field style="width: 100%">
          <mat-label>Correo Peronal Involucrado</mat-label>
          <input
            type="text"
            [(ngModel)]="correo"
            matInput
            placeholder="Ingrese su correo"
          />
          <!-- <mat-error *ngIf="form.get('email_usado').hasError('required')"
            >El correo es <strong>requerido</strong></mat-error
          >
          <mat-error *ngIf="form.get('email_usado').hasError('email')"
            >El correo es <strong>invalido</strong></mat-error
          > -->
        </mat-form-field>
        <mat-form-field style="width: 100%">
          <mat-label>Nombre Peronal Involucrado(completo)</mat-label>
          <input
            type="text"
            [(ngModel)]="nombre"
            matInput
            placeholder="Ingrese nombre completo"
          />
        </mat-form-field>
        <mat-form-field style="width: 100%">
          <mat-label>NM</mat-label>
          <input
            type="text"
            [(ngModel)]="nm"
            matInput
            placeholder="Ingrese nm"
          />
        </mat-form-field>
      </div>
    </div>
    <div
      class="checkboxs"
      *ngIf="
        tarea.titulo === 'Aprobar Evaluación del Especialista' &&
        caso.tipo_caso === 'Investigación de asuntos internos'
      "
    >
      <label
        class="checkbox"
        (click)="asuntosInternosPersonalInternoInvolucrado(true)"
      >
        <span>Personal interno involucrado (SI)</span>
        <i
          class="fas fa-{{
            form.value.personalInternoInvolucrado ? 'check-circle' : 'circle'
          }}"
        ></i>
      </label>
      <label
        class="checkbox"
        (click)="asuntosInternosPersonalInternoInvolucrado(false)"
      >
        <span>Personal interno involucrado (NO)</span>
        <i
          class="fas fa-{{
            form.value.personalInternoInvolucrado ? 'circle' : 'check-circle'
          }}"
        ></i>
      </label>
    </div>
    <!-- <div class="card bg-light mb-3" style="max-width: 33rem; max-height: 4rem;"
      *ngIf="
        tarea.titulo === 'Aprobar Evaluación del Especialista' &&
        personalInterno === false &&
        ingresosDescono === false
      "
    >
      <div class="card-body d-flex justify-content-between align-items-center">
        <p class="card-text">¿Caso es una estafa?</p>
        <button class="botoncard" *ngIf="!estafa" (click)="estafaC()">
          Procesar bloqueo de cuentas involucradas
        </button>
        <div class="text-center" *ngIf="estafa">
          <mat-icon>done</mat-icon>
        </div>
      </div>
    </div> -->

    <!-- <div class="card bg-light mb-3" style="max-width: 33rem; max-height: 4rem;"
      *ngIf="
          tarea.titulo === 'Aprobar Evaluación del Especialista' &&
          estafa === false &&
          ingresosDescono === false
        "
    >
      <div class="card-body d-flex justify-content-between align-items-center">
        <p class="card-text">¿Personal interno involucrado?</p>
        <button class="botoncard" *ngIf="!personalInterno" (click)="personalInterC()">
          Procesar bloqueo de cuentas involucradas
        </button>
        <div class="text-center" *ngIf="personalInterno">
          <mat-icon>done</mat-icon>
        </div>
      </div>

    </div> -->
    <!-- <div class="card bg-light mb-3" style="max-width: 33rem; max-height: 4rem;"
      *ngIf="
            tarea.titulo === 'Aprobar Evaluación del Especialista' &&
            personalInterno === false &&
            estafa === false
          "
    >
      <div class="card-body d-flex justify-content-between align-items-center">
        <p class="card-text">¿La cuenta tiene ingresos no reconocidos?</p>
        <button class="botoncard" *ngIf="!ingresosDescono" (click)="ingresosDesconoC()">
          Emitir alerta preventiva en sistema SAIME
        </button>
        <div class="text-center" *ngIf="ingresosDescono">
          <mat-icon>done</mat-icon>
        </div>
      </div>
    </div> -->

    <div *ngIf="caso" class="text-center mt-4" style="margin-bottom: 10px">
      <button
        class="cancel-btn rounded"
        mat-raised-button
        *ngIf="
        includeAnalistaCasos && !tarea.requerido
        "
        (click)="delete()"
      >
        Eliminar Tarea
      </button>

      <button
        class="primary-btn rounded ml-3"
        mat-raised-button
        (click)="guardar()"
        *ngIf="
          (includeAnalistaCasos && asignadoAlCaso) ||
          tarea.titulo === 'Aprobar Evaluación del Especialista'
        "
      >
        {{ textoGuardar }}
      </button>
    </div>
  </div>
</div>
